import IconButton from '@material-ui/core/IconButton';
import {Edit} from '@material-ui/icons';
import Visibility from '@material-ui/icons/Visibility';
import {Roles} from 'app/Constants';
import {useToggle} from 'components/hooks';
import IntegrityRoleGrid from 'components/UserRole';
import {Column, Lookup} from 'devextreme-react/data-grid';
import {i18n2} from 'features/i18n/i18n';
import React, {useState} from 'react';
import {
  useAddChoice,
  useDeleteChoice,
  useLoadChoices,
  useUpdateChoice,
} from '../hooks/index';
import {CreateChoicePopup, IntegrityChoiceGrid} from './index';
import {useIsTablet} from 'components/hooks/useIsTablet';
import {
  useActionButtonStyles,
  getActionColumnWidth,
} from 'components/grid-dx/styles/actionButtonStyles';

export const lookupType = {
  store: {
    type: 'array',
    data: [
      {id: 0, name: i18n2._('Simple')},
      {id: 1, name: i18n2._('Multiple')},
    ],
    key: 'id',
  },
};

const SeeDetails = ({row, refresh, noEdit, ids}) => {
  const isTablet = useIsTablet();
  const styles = useActionButtonStyles();
  const {open, setClose, setOn} = useToggle();
  return (
    <>
      <IconButton
        onClick={setOn}
        size="small"
        title={i18n2._('Ver')}
        className={isTablet ? styles.tabletButton : styles.compactButton}>
        <Visibility
          className={isTablet ? styles.tabletIcon : styles.compactButton}
        />
      </IconButton>
      {open && (
        <CreateChoicePopup
          open={open}
          handleClose={() => setClose(false)}
          edit={row}
          refresh={refresh}
          noEdit={noEdit}
          ids={ids}
        />
      )}
    </>
  );
};

const EditButton = ({row, refresh, noEdit, ids}) => {
  const isTablet = useIsTablet();
  const styles = useActionButtonStyles();
  const [openPopupChoice, setOpenPopupChoice] = useState(false);
  const updateChoice = useUpdateChoice();
  const handleClick = () => {
    setOpenPopupChoice(true);
  };

  return (
    <div style={{float: 'left', paddingRight: 5}}>
      <IconButton
        size="small"
        title={i18n2._('Editar')}
        className={isTablet ? styles.tabletButton : styles.compactButton}
        onClick={handleClick}>
        <Edit className={isTablet ? styles.tabletIcon : styles.compactButton} />
      </IconButton>
      {openPopupChoice && (
        <CreateChoicePopup
          open={openPopupChoice}
          handleClose={() => setOpenPopupChoice(false)}
          edit={row}
          remoteChange={updateChoice}
          refresh={refresh}
          noEdit={noEdit}
          ids={ids}
        />
      )}
    </div>
  );
};

const MAX_ACTION_BUTTONS = 1;

const Buttons = ({data, noEdit, refresh, ids}) => {
  const isTablet = useIsTablet();
  const styles = useActionButtonStyles();

  if (data.deleted) {
    return null;
  }
  return (
    <div
      className={isTablet ? styles.tabletContainer : styles.compactContainer}>
      {!noEdit ? (
        <EditButton row={data} refresh={refresh} noEdit={noEdit} ids={ids} />
      ) : (
        <SeeDetails noEdit={noEdit} row={data} ids={ids} />
      )}
    </div>
  );
};

const ChoicePage = ({props}) => {
  const noEdit = props.read;
  const isTablet = useIsTablet();
  const loadChoices = useLoadChoices(props.idCourse, props.idContent);
  const deleteChoice = useDeleteChoice();
  const ids = {
    idCourse: props.idCourse,
    idContent: props.idContent,
  };

  const CustomAddPopup = (open, setOpen, refresh) => {
    const addChoice = useAddChoice();
    return (
      <CreateChoicePopup
        open={open}
        handleClose={() => setOpen(false)}
        remoteAdd={addChoice}
        ids={ids}
        refresh={refresh}
      />
    );
  };

  return (
    <>
      <IntegrityRoleGrid
        allowEdit={[Roles.AdminQA, Roles.AdminHSE, Roles.AdminITPS]}
        dataSource={loadChoices}
        id={['iD_Choice', 'iD_Course', 'iD_Content']}
        promiseDelete={!noEdit ? deleteChoice : null}
        customEditPopup={true}
        componentAddPopup={CustomAddPopup}
        integrityGrid={IntegrityChoiceGrid}
        integrityId={['iD_Course', 'iD_Content']}
        integrityName={'Choice'}
        allowActions={!noEdit}
        height={'60vh'}>
        <Column caption={i18n2._('#Pregunta')} dataField="iD_Choice" />
        <Column caption={i18n2._('Titulo')} dataField="question" />
        <Column caption={i18n2._('Tipo')} dataField="type">
          <Lookup dataSource={lookupType} valueExpr="id" displayExpr="name" />
        </Column>
        <Column caption={i18n2._('Revision')} dataField="revision" />
        <Column caption={i18n2._('Motivo')} dataField="reason" />
        <Column
          caption={i18n2._('Fecha de actualizacion')}
          dataField="updateDate"
          defaultSortOrder={'desc'}
          dataType="date"
          format="dd/MM/yyyy"
          calculateCellValue={(row) => new Date(row.updateDate)}
        />
        <Column caption={i18n2._('Actualizado por')} dataField="updatedBy" />
        <Column
          caption={i18n2._('Eliminado')}
          dataField="deleted"
          width={100}
        />
        <Column
          caption=""
          cellComponent={(e) => (
            <Buttons
              data={e.data.data}
              noEdit={noEdit}
              refresh={e.data.component.refresh}
              ids={ids}
            />
          )}
          width={getActionColumnWidth(MAX_ACTION_BUTTONS, isTablet)}
          fixed
          alignment="right"
        />
      </IntegrityRoleGrid>
    </>
  );
};

export default ChoicePage;
